import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilsService } from 'utils-service-lib';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.css'],
    standalone: false
})
export class DialogConfirmComponent implements OnInit, OnDestroy {
  constructor(
    public dialogRef: MatDialogRef<any>,
    private utilsService: UtilsService,
    @Inject(MAT_DIALOG_DATA) public data: IDialogConfirm
  ) {}

  // Keyboard Shortcut - Use Esc to clear
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {
    if (!this.utilsService.escapableElementActive()) {
      if (event.code === 'Escape') {
        this.dialogRef.close();
      }
    } else {
      this.utilsService.escapableElementActive(false);
    }
  }

  ngOnInit(): void {
    this.utilsService.escapableElementActive(true);
  }

  ngOnDestroy(): void {
    this.utilsService.escapableElementActive(false);
  }
}

export interface IDialogConfirm {
  title: string;
  titleIcon: string;
  message: string;
  negativeText: string;
  positiveText: string;
  alternativeText: string;
}
